import HttpService from "./HttpService";
const API_ENDPOINT = "/my_profile";

const MyProfileService = {
  async getUserProfile() {
    try {
      const response = await HttpService.get(
        `${API_ENDPOINT}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default MyProfileService;
